import { UUID } from '@finxone-platform/shared/base-types';
import {
  Constants,
  defaultFilterPillsConfig,
  WidgetNames,
  WidgetTitles,
  WorkflowWidgetConfig,
} from '@finxone-platform/shared/sys-config-types';

export const supportChatsListWidgetConfig: WorkflowWidgetConfig = {
  widgetTypeConfig: 'new',
  uniqueId: new UUID().toString(),
  name: WidgetNames.SUPPORT_CHAT_LIST_WIDGET,
  widgetConfiguration: {
    widgetDisplayName: WidgetTitles.SUPPORT_CHAT_LIST_WIDGET,
    widgetConfigDisplayName: WidgetTitles.SUPPORT_CHAT_LIST_WIDGET,
    attributes: {
      elementsConfig: [],
      name: WidgetNames.SUPPORT_CHAT_LIST_WIDGET,
      label: WidgetTitles.SUPPORT_CHAT_LIST_WIDGET,
      css_config: {
        ...Constants.defaultBaseCssConfig,
        fontSize: 16,
        textFont: 'var(--font-family)',
        textAlignment: 'space-between',
        borderRadiusTopLeft: 0,
        borderRadiusBottomLeft: 0,
        borderRadiusTopRight: 0,
        borderRadiusBottomRight: 0,
        borderWidth: 0,
        borderColor: 'var(--color-border-color)',
        borderStyle: 'solid',
      },
      filterPillConfig: defaultFilterPillsConfig,
      widgetProperties: {
        textContent: `
        <div class="d-flex align-items-center w-100 mb-3 gap-2 {{#if (eq unreadCount
                0)}}unread{{else}}read{{/if}}">
          <div class="chat-icon-wrapper is-center">
              {{{ svgIcon 'user-profile' '18px' '18px' }}}
          </div>
          <div class="chat-text d-flex w-100 justify-content-between">
              <div class="flex-1">
                  <p class="body1">{{subject}}</p>
                  <p class="textOnSurfaceMuted last-message-preview text-[12px]">{{lastMessage.content}}</p>
              </div>
              <div class="flex-shrink-0 d-flex flex-col">
                  <p class="font-weight-semi textOnSurfaceMuted date-time-text">{{datePipe updatedAt format='HH:mm' }} {{#if (eq unreadCount
                      0)}}<span class="pl-1">{{datePipe updatedAt format='dd/MM' }}</span>{{/if}}</p>
                  {{#if (neq unreadCount
                      0)}}<div class="chat-unread-count-badge mt-1"></div>{{/if}}
              </div>
          </div>
        </div>`,
        appBuilderState: 'default',
      },
      fetchingTemplate: 'Loading...',
      noRecordsTemplate: 'No chats available',
      customStyles: `
      .read {
        font-weight: bold;
      }

      .unread {
        font-weight: 400;
      }
      .active-chat {
        border: 2px solid var(--color-active);
      }
      .last-message-preview {
        display: -webkit-box;
        -webkit-line-clamp: 1;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      .date-time-text {
        font-size: 12px;
      }

      .chat-icon-wrapper {
        height: 40px;
        width: 45px;
        background: var(--color-surface);
        color: var(--color-on-surface-muted);
        border-radius: 100%;
      }

      .chat-unread-count-badge {
        height: 15px;
        width: 15px;
        border-radius: 100%;
        background: var(--color-active);
        margin-left: auto;
      }`,
    },
    isRemovable: true,
  },
  widgetIconPath: 'listing',
};

export const supportChatWidgetConfig: WorkflowWidgetConfig = {
  widgetTypeConfig: 'new',
  uniqueId: new UUID().toString(),
  name: WidgetNames.SUPPORT_CHAT_WIDGET,
  widgetConfiguration: {
    widgetDisplayName: WidgetTitles.SUPPORT_CHAT_WIDGET,
    widgetConfigDisplayName: WidgetTitles.SUPPORT_CHAT_WIDGET,
    attributes: {
      elementsConfig: [],
      name: WidgetNames.SUPPORT_CHAT_WIDGET,
      label: WidgetTitles.SUPPORT_CHAT_WIDGET,
      outerCss: ``,
      css_config: {
        ...Constants.defaultBaseCssConfig,
        iconSize: '32',
        iconUnit: 'px',
        iconColor: 'var(--color-on-primary)',
      },
      widgetProperties: {
        textContent: ``,
        icon: 'plane',
      },
      noActiveChatTemplate: 'No active chats found',
      closedChatTemplate: 'This chat is closed',
      customCss: `
      :root {
        --supportChatWidgetContainerBackground: var(--color-surface);
        --supportChatWidgetMessagesContainerHeight: 69vh;
        --supportChatWidgetMessagesContainerPadding: 1rem;
        --supportChatWidgetMessageFontFamily: var(--font-family);
        --supportChatWidgetMessagePadding: 15px;
        --supportChatWidgetMessageMaxWidth: 90%;
        --supportChatWidgetSentMessageColor: var(--color-on-primary);
        --supportChatWidgetSentMessageBackground: var(--color-primary);
        --supportChatWidgetSentMessageBorderRadius: 16px 16px 0 16px;
        --supportChatWidgetReceivedMessageColor: var(--color-on-background);
        --supportChatWidgetReceivedMessageBackground: var(--color-background);
        --supportChatWidgetReceivedMessageBorderRadius: 16px 16px 16px 0;
        --supportChatWidgetInputContainerBackground: var(--color-background);
        --supportChatWidgetInputContainerPadding: 0.5rem;
        --supportChatWidgetInputBackground: var(--color-background);
        --supportChatWidgetInputBorderColor: var(--color-border-color);
        --supportChatWidgetInputTextColor: var(--color-on-background);
        --supportChatWidgetInputPlaceholderColor: var(--color-on-background-muted);
        --supportChatWidgetInputActiveBorderColor: var(--color-primary);
        --supportChatWidgetClosedChatMessageColor:var(--color-on-surface-muted);
        --supportChatWidgetDateSeparatorColor: var(--color-on-surface-muted);
        --supportChatWidgetDateSeparatorFontSize: 14px;
      }
      `,
    },
    isRemovable: true,
  },
  widgetIconPath: 'chat',
};
